import { Component, OnDestroy } from "@angular/core";
import { AdminMenusService } from "../admin-sidebar/admin-menus.service";
import { CommonfunctionService } from "../../services/commonfunction.service";
import { Router } from "@angular/router";
import { ApiserviceService } from "../../apiservice.service";
import { NotificationService } from "../services/notification.service";
import { Observable, Subscription } from "rxjs";

@Component({
  selector: "app-log-setting",
  templateUrl: "./log-setting.component.html",
  styleUrls: ["./log-setting.component.scss"],
})
export class LogSettingComponent implements OnDestroy {
  selectedTabIndex: number = 0;
  log_setting_access: {
    GET: boolean;
    PATCH: boolean;
    POST: boolean;
    DELETE: boolean;
  };
  dblogTypeList: [];
  apilogTypeList: [];
  toggleStatus: any = false;
  selectedService: string = "ems";
  loader: boolean = false;
  private subs = new Subscription();

  constructor(
    private readonly fnc: CommonfunctionService,
    private readonly router: Router,
    private readonly api: ApiserviceService,
    private readonly notify: NotificationService,
    private readonly menu: AdminMenusService
  ) {
    this.menu.setActive("log-setting");
  }

  servicesOptions = [
    { value: "ems", label: "EMS" },
    { value: "eps", label: "EPS" },
    { value: "csvupload", label: "CSV Upload" },
    { value: "sync", label: "Sync" },
  ];

  tableColumn: string[] = ["id", "log_type", "description", "log_status"];

  getAllowResource() {
    this.log_setting_access = this.fnc.checkResourceAccess(
      "log_setting",
      false
    );
    if (!this.log_setting_access.GET) {
      this.router.navigateByUrl("/admin/login");
    } else {
      this.getDbLogs();
      this.getApiLogs(this.selectedService);
    }
  }

  getAlowResourcesApi() {
    this.api.getUserRole();
    let body = `user/resource?place_id=${this.api.city_id}&user_id=${this.api.user_id}`;
    const allowResSub = this.api.getUmsData(body).subscribe({
      next: (res: any) => {
        this.api.allowResources = res.data;
        this.getAllowResource();
      },
      error: (err) => {},
    });
    this.subs.add(allowResSub);
  }
  ngOnInit() {
    this.getAlowResourcesApi();
    this.selectedService = this.servicesOptions[0].value;
  }

  onServiceChange(service: string): void {
    this.selectedService = service;
    this.getApiLogs(service);
  }

  //get db data
  getDbLogs() {
    if (!this.log_setting_access.GET) {
      this.notify.notify("User not Authorized to Get Log Setting Data", "warn");
      return;
    }

    let url = "/db-log-settings";
    this.loader = true;
    const dbLogSub = this.api.getEmsData(url).subscribe({
      next: (response: any) => {
        this.loader = false;
        this.dblogTypeList = response.data;
      },
      error: () => {
        this.loader = false;
        this.dblogTypeList = [];
      },
    });
    this.subs.add(dbLogSub);
  }

  //update db status
  updateDbLogStatus(event: { logType: string; status: number; source?: any }) {
    if (!this.log_setting_access.PATCH) {
      this.notify.notify(
        "User not Authorized to Update DB Log Setting Status",
        "warn"
      );
      event.source.checked = !event.source.checked;
      return;
    }
    const { logType, status } = event;
    let url = "/db-log-settings";

    let body: any = {
      log_type: logType,
      status: status,
      updated_by: this.api.user_id,
    };

    this.loader = true;
    const updateDbLogStatusSub = this.api.patchEmsData(url, body).subscribe({
      next: (response: any) => {
        this.loader = false;
        this.notify.notify(response.message, "success");
        this.getDbLogs();
      },
      error: (error) => {
        this.loader = false;
      },
    });
    this.subs.add(updateDbLogStatusSub);
  }

  //get api data
  getApiLogs(service: string) {
    if (!this.log_setting_access.GET) {
      this.notify.notify("User not Authorized to Get Log Setting Data", "warn");
      return;
    }

    const url = "/api-log-settings";

    const serviceApiMap: { [key: string]: (url: string) => Observable<any> } = {
      eps: this.api.getEpsData.bind(this.api),
      ems: this.api.getEmsData.bind(this.api),
      csvupload: this.api.getCsvData.bind(this.api),
      sync: this.api.getSyncData.bind(this.api),
    };

    const apiCall = serviceApiMap[service];

    const apiLogSub = apiCall(url).subscribe({
      next: (response: any) => {
        this.apilogTypeList = response.data;
      },
      error: (error) => {
      },
    });
    this.subs.add(apiLogSub);
  }

  // update api status
  updateApiLogStatus(event: { logType: string; status: number; source?: any }) {
    if (!this.log_setting_access.PATCH) {
      this.notify.notify(
        "User not Authorized to Update API Log Setting Status",
        "warn"
      );
      event.source.checked = !event.source.checked;
      return;
    }

    const { logType, status } = event;
    const url = `/log-toggle?log_type=${logType}&status=${status}`;

    const serviceApiMap: { [key: string]: (url: string) => Observable<any> } = {
      eps: this.api.getEpsData.bind(this.api),
      ems: this.api.getEmsData.bind(this.api),
      csvupload: this.api.getCsvData.bind(this.api),
      sync: this.api.getSyncData.bind(this.api),
    };

    const apiCall = serviceApiMap[this.selectedService];

    const updateApiLogSub = apiCall(url).subscribe({
      next: (response: any) => {
        this.notify.notify(response.message, "success");
        this.getApiLogs(this.selectedService);
      },
      error: (error) => {
      },
    });
    this.subs.add(updateApiLogSub);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
